export default "__VITE_ASSET__DQ7zw6Mt__"